/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState } from 'react';
import { View, TouchableOpacity, StyleSheet } from 'react-native';
import Colors from '@global/colors';
import { isWeb, isMobileWeb } from '@global/screens';
import Alert from '@components/global/Alert';
import SociollaText from '@components/sociolla/SociollaText';
import Image from '@components/global/Image';
import Modal from '@components/modal/Modal';

const MoreButton = (props) => {
  const testID = props.testID || 'more-button';
  const [showMenu, setShowMenu] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertOptions, setAlertOptions] = useState({});

  const onClose = () => {
    setShowMenu(false);
  };

  const onClicked = (item) => {
    setAlertOptions(item);
    if (['confirm', 'info'].includes(item.type)) {
      setShowAlert(true);
    } else if (item.type == 'redirect') {
      if (item.screen) {
        try {
          let params = {};
          if (item.params && Object.keys(item.params).length) {
            params = item.params;
          }
          // eslint-disable-next-line react/prop-types
          props.navigation.navigate(item.screen, params);
        } catch (error) {}
      }
    } else if (item.type == 'fetch') {
      console.log('Fetching');
    } else if (item.type == 'function') {
      item.callback();
    } else if (item.type == 'props') {
      // eslint-disable-next-line react/prop-types
      props.callback(item);
    } else {
      console.log('Nothing');
    }
    setShowMenu(false);
  };

  const onCancel = () => {
    setShowAlert(false);
    setAlertOptions({});
  };

  const onOk = () => {
    setShowAlert(false);
    setAlertOptions({});
  };

  return !isWeb || isMobileWeb ? (
    <View testID={testID}>
      <TouchableOpacity
        testID={`${testID}-btn`}
        onPress={() => setShowMenu(true)}
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          paddingHorizontal: 15,
        }}>
        <Image
          width={20}
          height={isMobileWeb ? 4 : 20}
          style={{ width: 20, height: isMobileWeb ? 4 : 20 }}
          svg={true}
          source={require('@assets/img/icons/more-white.svg')}
        />
      </TouchableOpacity>
      <Alert
        show={showAlert}
        title={alertOptions.title}
        description={alertOptions.description}
        hideCancel={alertOptions.type != 'confirm'}
        onCancel={() => onCancel()}
        onOk={() => onOk()}
      />
      <Modal
        transparent={true}
        visible={showMenu}
        animationType="none"
        onClose={() => onClose()}>
        <View testID={`${testID}-menu`} style={styles.menu}>
          {(props.menu || []).map((item, idx) => (
            <TouchableOpacity
              testID={`${testID}-menu-item-${idx}`}
              activeOpacity={0.6}
              style={styles.menuItem}
              onPress={() => onClicked(item)}
              key={idx}>
              <SociollaText style={{ fontSize: 14, letterSpacing: 0.5 }}>
                {item.name}
              </SociollaText>
            </TouchableOpacity>
          ))}
        </View>
      </Modal>
    </View>
  ) : (
    false
  );
};

const styles = StyleSheet.create({
  menu: {
    position: isMobileWeb ? 'fixed' : 'absolute',
    top: 55,
    right: 0,
    backgroundColor: Colors.white,
    width: 250,
  },
  menuItem: {
    color: Colors.blue1,
    padding: 15,
    borderBottomColor: Colors.grey0,
    borderBottomWidth: 1,
  },
});

export default React.memo(MoreButton, (prev, next) => prev == next);
